import type { CSSProperties, ReactNode } from "react";
import css from "./primitives.module.css";

type PanelProps = {
  children: ReactNode;
  /** Drops the 4px hard shadow, for panels sitting flush inside another. */
  flush?: boolean;
  as?: "div" | "section" | "article" | "aside";
  className?: string;
  style?: CSSProperties;
};

export function Panel({ children, flush, as: Tag = "div", className, style }: PanelProps) {
  const classes = [css.panel, flush ? css.panelFlush : "", className ?? ""]
    .filter(Boolean)
    .join(" ");
  return (
    <Tag className={classes} style={style}>
      {children}
    </Tag>
  );
}
